/** Structured omission codes from `price_history_omitted.code`. */
export const OMISSION_REASON_CHOICES = [
  {
    code: "no_product_name",
    label: "No Product Name",
    meaning: "Analysis produced no product name.",
  },
  {
    code: "unresolved_product",
    label: "Unresolved Product",
    meaning:
      "We could not match this item to a product in our catalog (name/override lookup failed, and barcode matching did not confirm a product).",
  },
  {
    code: "no_closest_product",
    label: "No Closest Product",
    meaning:
      "A product candidate was found, but it was not a confident enough match to save as a price history row.",
  },
  {
    code: "no_record_at",
    label: "No Record At",
    meaning: "The photo had no usable date (no camera date or file upload date), so the price could not be dated.",
  },
  {
    code: "future_record_at",
    label: "Future Record At",
    meaning: "The date from the photo is in the future, so the price was not saved.",
  },
  {
    code: "no_canonical_retailer",
    label: "No Canonical Retailer",
    meaning:
      "The product was recognized, but the store name could not be matched to a known retailer (from the photo text or location).",
  },
  {
    code: "invalid_price",
    label: "Invalid Price",
    meaning: "The price or unit price was zero or negative, so it was not saved.",
  },
  {
    code: "protected_row",
    label: "Protected Row",
    meaning:
      "A locked or voided price already exists for this product from the same photo run, so a duplicate was not added.",
  },
  {
    code: "barcode_unsupported",
    label: "Barcode Unsupported",
    meaning: "This barcode is marked as unsupported (for example a non-Canadian product), so it was skipped.",
  },
];

const REASON_BY_CODE = Object.fromEntries(
  OMISSION_REASON_CHOICES.map((entry) => [entry.code, entry])
);

export function getOmissionReason(code) {
  if (!code) {
    return { code: "", label: "-", meaning: "" };
  }

  return (
    REASON_BY_CODE[code] || {
      code,
      label: formatOmissionCodeLabel(code),
      meaning: "",
    }
  );
}

export function formatOmissionCodeLabel(code) {
  if (!code || typeof code !== "string") {
    return code || "-";
  }

  return code
    .split("_")
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
}
